import { FC } from 'react';

import { connect } from '../store/';
import PlayerNoIMA from './RmpVastPlayer';
import PlayerIMA from './IMAPlayer';

export type DefaultPlayerProps = { videoIMAFailed: boolean };

export const DefaultPlayer: FC<DefaultPlayerProps> = ({ videoIMAFailed }) => (
  videoIMAFailed ? <PlayerNoIMA /> : <PlayerIMA />
);

export default connect(['videoIMAFailed'])(DefaultPlayer);
